import React from 'react'

const Circle = ({ className, src, alt }) => {
    return (
        <img className={className} src={src} alt={alt} width={900} height={900} />
    )
}

export default Circle
